import MainLayout from 'tailwind-components/MainLayout/MainLayout';
import Loader from 'tailwind-components/Loader/Loader';
import NotificationBar from 'components/NotificationBar/NotificationBar';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useNotifyTourPageReady from 'tailwind-components/PortalWalkthrough/useNotifyTourPageReady';
import { isMobileWebView } from 'helpers/mobileWebView';

//This component sets the active page in the sidebar
// and fetch the initial data from zoho
// useLocalLoader: when false, the loader is never shown (e.g. when data is fetched at app level)
// loadingStateSelector: when useLocalLoader is false, optional selector (state) => boolean to drive loader from Redux (e.g. state => state.dashboard.loadingDashboard)
function withLocalLoader(
  Component,
  fullHeader,
  activePage,
  subPage = '',
  useLocalLoader = true,
  loadingStateSelector = null
) {
  const WithLocalLoader = ({ ...componentProps }) => {
    const [localLoader, setLocalLoader] = useState(useLocalLoader);
    const loadingFromRedux = useSelector(state =>
      loadingStateSelector ? loadingStateSelector(state) : false
    );
    const showLoader = useLocalLoader ? localLoader : loadingFromRedux;

    useNotifyTourPageReady(showLoader);

    useEffect(() => {
      if (!showLoader) return undefined;

      const previousBodyOverflow = document.body.style.overflow;
      const previousHtmlOverflow = document.documentElement.style.overflow;
      const scrollContainers = Array.from(document.querySelectorAll('main'));
      const previousContainerOverflow = [];

      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      for (const container of scrollContainers) {
        previousContainerOverflow.push({
          container,
          overflow: container.style.overflow,
          overflowY: container.style.overflowY
        });
        container.style.overflow = 'hidden';
        container.style.overflowY = 'hidden';
      }

      return () => {
        document.body.style.overflow = previousBodyOverflow;
        document.documentElement.style.overflow = previousHtmlOverflow;

        for (const {
          container,
          overflow,
          overflowY
        } of previousContainerOverflow) {
          container.style.overflow = overflow;
          container.style.overflowY = overflowY;
        }
      };
    }, [showLoader]);

    return (
      <MainLayout
        fullHeader={fullHeader}
        activePage={activePage}
        contentOverlay={showLoader ? <Loader /> : null}
        topBanner={
          isMobileWebView() ? null : (
            <NotificationBar currentPage={activePage} subPage={subPage} />
          )
        }
      >
        <Component
          {...componentProps}
          localLoader={localLoader}
          setLocalLoader={setLocalLoader}
        />
      </MainLayout>
    );
  };

  return WithLocalLoader;
}

export default withLocalLoader;
